import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
import Logo from '@/components/Logo';

export const PHONE_DISPLAY = '(855) 784-7627';
export const PHONE_TEL = 'tel:+18557847627';

const trackGA = (event, data = {}) => {
  if (window.gtag) window.gtag('event', event, data);
};

/**
 * Minimal nav used across paid-traffic landing pages.
 * Logo + single "Call Us" CTA. No menu links.
 */
export default function LandingNav({ logoTo = '/get-quote' }) {
  return (
    <nav
      className="sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-[hsl(var(--border))]"
      data-testid="landing-nav"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to={logoTo} className="flex items-center" data-testid="nav-logo-link">
          <Logo variant="light" size="xsmall" />
        </Link>
        <a
          href={PHONE_TEL}
          data-testid="nav-call-us-cta"
          onClick={() =>
            trackGA('phone_call_click', {
              event_category: 'engagement',
              event_label: 'header_call_us',
            })
          }
          className="inline-flex items-center gap-2 rounded-xl px-4 sm:px-5 h-11 border-2 border-[var(--brand-ocean-600)] text-[var(--brand-ocean-700)] font-semibold text-sm hover:bg-[var(--brand-ocean-100)]/40 transition-colors"
        >
          <Phone className="h-4 w-4" />
          <span className="hidden sm:inline">Call Us</span>
          <span className="sm:hidden">Call</span>
        </a>
      </div>
    </nav>
  );
}
